import { produce } from 'immer';

import {
  getSRUserDetails,
  cleanSRUserDetails,
  getSRUserPayments,
  sendSRUserTransferRequest,
} from '../actions/srUsers';

const initialState = {
  userDetails: {},
  payments: {
    data: [],
    meta: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
    },
  },
  loadings: {
    userDetails: false,
    userPayments: false,
    userTransfer: false,
  },
};

const reducer = produce((state = initialState, action) => {
  switch (action.type) {
    // GET USER DETAILS
    case getSRUserDetails.types.START:
      state.loadings.userDetails = true;
      return state;

    case getSRUserDetails.types.SUCCESS:
      state.userDetails = action.payload.data;
      state.loadings.userDetails = false;
      return state;

    case getSRUserDetails.types.FAIL:
      state.loadings.userDetails = false;
      return state;

    // CLEAN USERS DETAILS
    case cleanSRUserDetails.types.INIT:
      state.userDetails = initialState.userDetails;
      state.payments = initialState.payments;
      return state;

    // GET USER PAYMENTS
    case getSRUserPayments.types.START:
      state.loadings.userPayments = true;
      return state;

    case getSRUserPayments.types.SUCCESS:
      state.payments.data = [...state.payments.data, ...action.payload.data];
      state.payments.meta = action.payload.meta;
      state.loadings.userPayments = false;
      return state;

    case getSRUserPayments.types.FAIL:
      state.loadings.userPayments = false;
      return state;

    // REQUEST USER TRANSFER
    case sendSRUserTransferRequest.types.START:
      state.loadings.userTransfer = true;
      return state;

    case sendSRUserTransferRequest.types.SUCCESS:
      if (state.userDetails.streaming_rewards) {
        state.userDetails.streaming_rewards.map(reward => {
          if (reward.id === action.payload.streaming_reward_id) {
            reward.transfer_request = action.payload.transfer_request;
          }

          return reward;
        });
      }

      state.loadings.userTransfer = false;
      return state;

    case sendSRUserTransferRequest.types.FAIL:
      state.loadings.userTransfer = false;
      return state;

    default:
      return state;
  }
});

export default reducer;
